const { default: useFetchData } = require('../../../../../hooks/fetchHook');

export const useGetBrandAliases = ({ ignore }) => {
  const [{ data = [], isLoading, isError, error }] = useFetchData(
    'admin_brands/aliases',
    {
      formatter,
      ignore,
    }
  );

  return { data, isLoading, isError, error };
};

const formatter = data => {
  return data.map(({ brAlias }) => brAlias);
};
